import React from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import styles from '../views/SettingAccount/SettingAccountView.module.scss'

export default function ListHistory({ whatYouNeed }) {
  const rows = (whatYouNeed && whatYouNeed.history) || []
  const { t, i18n } = useTranslation()

  // Map status API → label dịch
  function statusLabel(status) {
    const s = (status || '').toLowerCase()
    if (s === 'done' || s === 'completed' || s === 'success')
      return { text: t('setting_account.history_status_done'), isDone: true, cls: styles.statusDone }
    if (s === 'pending')
      return { text: t('setting_account.history_status_pending'), isDone: false, cls: '' }
    if (s === 'running')
      return { text: t('setting_account.history_status_running'), isDone: false, cls: '' }
    return { text: status || '—', isDone: false, cls: '' }
  }

  // Map method API → label dịch
  // Nếu ngôn ngữ là tiếng Anh thì map sang EN, còn lại giữ nguyên giá trị API
  function methodLabel(method) {
    if (!method) return '—'
    const isEn = i18n.language?.startsWith('en')
    if (!isEn) return method // tiếng Việt: giữ nguyên từ API

    // Map tiếng Việt → key dịch
    const map = {
      'chuyển khoản': t('setting_account.history_method_bank_transfer'),
      'the tin dung': t('setting_account.history_method_card'),
      'thẻ tín dụng': t('setting_account.history_method_card'),
      'momo': t('setting_account.history_method_momo'),
      'ví momo': t('setting_account.history_method_momo'),
      'paypal': t('setting_account.history_method_paypal'),
      'tiền mặt': t('setting_account.history_method_cash'),
    }
    return map[method.toLowerCase()] || method
  }

  if (rows.length === 0) {
    return (
      <p style={{ color: 'var(--text-tertiary)', fontSize: 13, padding: '20px 0', textAlign: 'center' }}>
        {t('update.no_data')}
      </p>
    )
  }

  return (
    <div className={styles.tblScroll}>
      <table className={styles.tbl}>
        <thead>
          <tr>
            <th>{t('account_management.payment_history.time')}</th>
            <th>{t('account_management.payment_history.order_code')}</th>
            <th>{t('account_management.payment_history.package')}</th>
            <th style={{ textAlign: 'right' }}>{t('account_management.payment_history.total')}</th>
            <th>{t('account_management.payment_history.method')}</th>
            <th>{t('account_management.payment_history.status')}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => {
            const { text, isDone, cls } = statusLabel(row.status)
            const amount = row.amount == null || row.amount === 0
              ? t('setting_account.history_amount_free')
              : `${Number(row.amount).toLocaleString()} ${row.currency || 'USD'}`
            return (
              <tr key={row.id || idx}>
                <td>
                  <div style={{ fontWeight: 500 }}>
                    {row.updatedAt ? moment(row.updatedAt).format('DD/MM/YYYY') : '—'}
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--text-tertiary)' }}>
                    {row.updatedAt ? moment(row.updatedAt).format('HH:mm') : ''}
                  </div>
                </td>
                <td><span className={styles.mono}>#{row.id}</span></td>
                <td>{row.name || '—'}</td>
                <td style={{ textAlign: 'right', fontWeight: 600 }}>{amount}</td>
                <td>{methodLabel(row.method)}</td>
                <td>
                  <span className={`${styles.statusBadge} ${cls}`}>
                    <span
                      className={styles.statusDot}
                      style={isDone ? { background: 'var(--green)' } : undefined}
                    />
                    {text}
                  </span>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
